{
  "name": "cms-pwa-simple-museum",
  "version": "1.0.3",
  "description": "YOUCA PWA based on the Elsa PWA",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "serve-dev": "ng serve --configuration development",
    "serve-prod": "ng serve --configuration production",
    "client-gen-keycloak": "openapi-generator-cli generate -g typescript-angular -o src/api/keycloak -i ./swagger/swagger_keycloak.json  --additional-properties=ngVersion=21.0.6",
    "client-gen-rest": "openapi-generator-cli generate -g typescript-angular -o src/api/rest -i ./swagger/swagger_rest.json --additional-properties=ngVersion=21.0.6",
    "client-gen-sync": "openapi-generator-cli generate -g typescript-angular -o src/api/sync -i ./swagger/swagger_sync.json --additional-properties=ngVersion=21.0.6",
    "client-gen-organization": "openapi-generator-cli generate -g typescript-angular -o src/api/organization -i ./swagger/swagger_organization.json --additional-properties=ngVersion=21.0.6",
    "generate-models": "npm run client-gen-rest && npm run client-gen-keycloak && npm run client-gen-sync && npm run client-gen-organization",
    "prebuild": "npm run generate-models",
    "build": "ng build --base-href / --deploy-url /",
    "build-dev": "ng build --base-href / --deploy-url / --configuration development",
    "build-stage": "ng build --base-href / --deploy-url / --configuration development",
    "build-prod": "ng build --base-href / --deploy-url / --configuration production",
    "build-local": "ng build --base-href / --deploy-url / --configuration production --outputPath=dist",
    "run-dev-android": "ng build --configuration development && npx cap sync && npx cap run android",
    "run-dev-ios": "ng build --configuration development && npx cap sync && npx cap run ios",
    "run-prod-android": "ng build --configuration production && npx cap sync && npx cap run android",
    "build-native-dev": "npm run generate-models && ng build --configuration development && npx cap sync",
    "serve-pwa": "http-server -p 8080 -c-1 dist",
    "test": "ng test",
    "eslint": "eslint",
    "lint": "eslint. "
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "~21.1.3",
    "@angular/cdk": "^21.1.3",
    "@angular/common": "~21.1.3",
    "@angular/compiler": "~21.1.3",
    "@angular/core": "~21.1.3",
    "@angular/forms": "~21.1.3",
    "@angular/google-maps": "^21.1.3",
    "@angular/localize": "~21.1.3",
    "@angular/material": "^21.1.3",
    "@angular/platform-browser": "~21.1.3",
    "@angular/platform-browser-dynamic": "~21.1.3",
    "@angular/router": "~21.1.3",
    "@angular/service-worker": "~21.1.3",
    "@capacitor/android": "^8.0.2",
    "@capacitor/app": "^8.0.0",
    "@capacitor/core": "^8.0.2",
    "@capacitor/ios": "^8.0.2",
    "@capacitor/share": "^8.0.0",
    "@ebarooni/capacitor-calendar": "^8.0.0",
    "@ngrx/effects": "^21.0.1",
    "@ngrx/entity": "^21.0.1",
    "@ngrx/router-store": "^21.0.1",
    "@ngrx/schematics": "^21.0.1",
    "@ngrx/store": "^21.0.1",
    "@ngrx/store-devtools": "^21.0.1",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "jwt-decode": "~4.0.0",
    "ngx-matomo-client": "9.0.1",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "uuid": "^8.3.2"
  },
  "devDependencies": {
    "@angular/build": "^21.1.2",
    "@angular/cli": "^21.1.4",
    "@angular/compiler-cli": "~21.1.3",
    "@angular/language-service": "~21.1.3",
    "@capacitor/cli": "^8.0.2",
    "@openapitools/openapi-generator-cli": "^2.28.1",
    "@types/jasmine": "~6.0.0",
    "@types/jasminewd2": "~2.0.13",
    "@types/node": "^25.2.0",
    "@typescript-eslint/eslint-plugin": "^8.54.0",
    "@typescript-eslint/parser": "^8.54.0",
    "angular-eslint": "21.2.0",
    "eslint": "^9.39.2",
    "typescript-eslint": "8.56.1",
    "http-server": "^14.1.1",
    "jasmine-core": "^6.0.1",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage-istanbul-reporter": "~3.0.3",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.2.0",
    "ts-node": "~10.9.2"
  }
}
